<template>
    <div>
        <div class="search-bar-margin-bottom-cla">
            <el-form class="search-from-cla" :inline="true" :model="params">
                <el-form-item :label="$t('apiLog.appCode')">
                    <el-select class="select-cla" v-model="params.appCode" clearable :placeholder="appCode">
                        <el-option v-for="item in appCodeOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item :label="$t('apiLog.method')">
                    <el-select class="select-cla" v-model="params.method" clearable :placeholder="method">
                        <el-option v-for="item in methodOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item :label="$t('apiLog.integrationUser')">
                    <el-input class="search-input" :placeholder="$t('apiLog.integrationUser')"
                        v-model.trim="params.integrationUser" clearable @clear="searchFn"
                        @keyup.enter.native="searchFn"></el-input>
                </el-form-item>

                <el-form-item :label="$t('apiLog.requestTime')">
                    <el-date-picker class="pickData_cla" v-model="timePick" @clear="searchFn" align="right" unlink-panels
                        range-separator="-" :start-placeholder="$t('common.startTime')"
                        :end-placeholder="$t('common.endTime')" :picker-options="pickerOptions" type="datetimerange"
                        :default-time="['00:00:00', '23:59:59']" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>

                <el-form-item :label="$t('apiLog.url')">
                    <el-input class="search-input" :placeholder="$t('apiLog.url')" v-model.trim="params.url" clearable
                        @clear="searchFn" @keyup.enter.native="searchFn"></el-input>
                </el-form-item>

                <el-form-item label="Mid">
                    <el-input class="search-input" :placeholder="this.$t('apiLog.mid')" v-model.trim="params.mid" clearable
                        @clear="searchFn" @keyup.enter.native="searchFn"></el-input>
                </el-form-item>

                <el-form-item v-if="!appLog" label="AppKey">
                    <el-input :placeholder="this.$t('apiLog.appKey')" v-model.trim="params.appKey" clearable
                        @clear="searchFn" @keyup.enter.native="searchFn"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-select class="select-cla" v-model="params.status" clearable :placeholder="this.$t('apiLog.result')">
                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="searchFn" icon="el-icon-search">
                        {{ this.$t('common.search') }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="black_panel_cla">
            <el-table @row-dblclick="dblclick" :data="tableData" :row-key="getRowKeys" style="width: 100%">
                <!-- <el-table-column
          prop="apiId"
          :label="$t('apiLog.apiName')"
        ></el-table-column> -->
                <el-table-column prop="url" :label="$t('apiLog.url')"></el-table-column>
                <el-table-column prop="method" :width="100" :label="$t('apiLog.method')"></el-table-column>
                <el-table-column prop="mid" :label="$t('apiLog.mid')"></el-table-column>
                <!-- <el-table-column
          v-if="!appLog"
          prop="appKey"
          :label="$t('apiLog.appKey')"
        ></el-table-column> -->

                <el-table-column prop="appName" :label="$t('apiLog.appName')"></el-table-column>

                <el-table-column :width="250" prop="requestTime" :label="$t('apiLog.requestTime')">
                    <template slot-scope="scope">{{
                        scope.row.requestTime | dataFormat('yyyy-MM-dd HH:mm:ss.S')
                    }}</template>
                </el-table-column>

                <el-table-column prop="elapsedMs" :width="70" :label="$t('apiLog.elapsedMs')"></el-table-column>

                <el-table-column :width="80" prop="status" :label="$t('apiLog.result')">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.status">
                            {{ $t('common.success') }}
                        </el-tag>
                        <el-tag v-else type="danger">
                            {{ $t('common.fail') }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column :width="70" :label="$t('common.action')">
                    <template slot-scope="scope">
                        <el-button class="btn-text-cla" @click.stop="detailsFn(scope.row)" type="text">{{
                            $t('common.details') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div v-if="!listOver && scrollId" class="load-more-cla">
                <el-button @click="loadMore" :loading="loading" class="load-more-btn-cla" type="text">{{
                    $t('com_log.loadMore') }}</el-button>
            </div>
        </div>
        <el-drawer :title="$t('apiLog.apiLog')" :visible.sync="drawer">
            <div style="text-align: right;">
                <el-button class="tag-read" :data-clipboard-text="JSON.stringify(currentRow)" @click="copy">
                    {{ $t('apiLog.copy') }}
                </el-button>
            </div>
            <template v-for="item of detailskey">
                <el-row :key="currentRow[item.key]" class="api-row-cla">
                    <el-col :span="6"> {{ item.name }}： </el-col>
                    <el-col :span="18">
                        <json-viewer v-if="item.isJson" :expand-depth="10" :value="currentRow[item.key]"></json-viewer>
                        <div v-else>
                            <template v-if="item.key === 'status'">
                                <el-tag type="success" v-if="currentRow[item.key]">
                                    {{ $t('common.success') }}
                                </el-tag>
                                <el-tag v-else type="danger">
                                    {{ $t('common.fail') }}
                                </el-tag>
                            </template>
                            <template v-else>
                                {{ currentRow[item.key] }}
                                <span v-if="item.key === 'elapsedMs'">ms</span>
                            </template>
                        </div>
                    </el-col>
                </el-row>
            </template>
        </el-drawer>
    </div>
</template>

<script>
import pickerOptions from '@/utils/pickerOptions.js'
import * as logApi from '@/services/logApi.js'
import { dateFormat, getCurrentDateStartAndEndTime } from '@/utils/utils.js'
import JsonViewer from 'vue-json-viewer'
import Clipboard from 'clipboard'
export default {
  data () {
    return {
      timePick: getCurrentDateStartAndEndTime(),
      pickerOptions: pickerOptions(this),
      scrollId: '',
      listOver: false,
      drawer: false,
      options: [
        {
          value: true,
          label: this.$t('common.success')
        },
        {
          value: false,
          label: this.$t('common.fail')
        }
      ],
      appCodeOptions: [
        {
          value: 'DBS',
          label: this.$t('apiLog.dbs')
        },
        {
          value: 'CC',
          label: this.$t('apiLog.cc')
        },
        {
          value: 'UFO',
          label: this.$t('apiLog.ufo')
        },
        {
          value: 'MINERVA',
          label: 'MINERVA'
        }
      ],
      methodOptions: [
        {
          value: 'GET',
          label: 'GET'
        },
        {
          value: 'POST',
          label: 'POST'
        },
        {
          value: 'PUT',
          label: 'PUT'
        },
        {
          value: 'DELETE',
          label: 'DELETE'
        },
        {
          value: 'PATCH',
          label: 'PATCH'
        },
        {
          value: 'HEAD',
          label: 'HEAD'
        },
        {
          value: 'OPTIONS',
          label: 'OPTIONS'
        },
        {
          value: 'TRACE',
          label: 'TRACE'
        }
      ],
      loadingInstance: null,
      params: {
        appKey: '',
        mid: '',
        status: '',
        appCode: 'DBS'
      },
      tableData: [],
      currentRow: {},
      detailskey: [
        {
          key: 'url',
          name: this.$t('apiLog.url')
        },
        {
          key: 'method',
          name: this.$t('apiLog.method')
        },
        {
          key: 'integrationUser',
          name: this.$t('apiLog.integrationUser')
        },
        {
          key: 'appKey',
          name: 'appKey'
        },
        {
          key: 'ip',
          name: 'ip'
        },
        {
          key: 'requestTime',
          name: this.$t('apiLog.requestTime')
        },
        {
          key: 'elapsedMs',
          name: this.$t('apiLog.elapsedMs')
        },
        {
          key: 'statusCode',
          name: this.$t('apiLog.statusCode')
        },
        {
          key: 'status',
          name: this.$t('apiLog.result')
        },
        {
          key: 'mid',
          name: 'mid'
        },
        {
          key: 'requestContent',
          name: this.$t('apiLog.requestContent'),
          isJson: true
        },
        {
          key: 'responseMessage',
          name: this.$t('apiLog.responseMessage'),
          isJson: true
        }
      ]
    }
  },
  props: {
    appInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    appLog: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.searchFn()
  },
  components: { JsonViewer },
  methods: {
    getRowKeys (row) {
      return row.id
    },
    detailsFn (row) {
      let temp = JSON.stringify(row)
      let curentRow = this.convertToJson(temp)
      this.currentRow = curentRow
      this.drawer = true
    },

    convertToJson (str) {
      try {
        let obj = JSON.parse(str)
        if (typeof obj === 'object') {
          return JSON.parse(str, (key, value) => {
            if (key === 'requestTime') {
              return dateFormat(new Date(value), 'yyyy-MM-dd HH:mm:ss.S')
            }
            if (value instanceof Array) {
              return value
            }
            return this.convertToJson(value)
          })
        } else {
          return str
        }
      } catch (error) {
        return str
      }
    },

    dblclick (row) {
      let temp = JSON.stringify(row)
      let curentRow = this.convertToJson(temp)
      this.currentRow = curentRow
      this.drawer = true
    },
    searchFn () {
      let params = {
        lookupFields: {
          appCode: ''
        }
      }
      if (this.scrollId) {
        params.lastScrollId = this.scrollId
      }
      if (this.timePick && this.timePick.length === 2) {
        params.startTime = this.timePick[0].getTime()
        params.endTime = this.timePick[1].getTime()
      }

      if (this.appLog && this.appInfo.appKey) {
        this.params.appKey = this.appInfo.appKey
      }
      Object.keys(this.params).forEach(key => {
        if (this.params[key] !== '') {
          if (!params.lookupFields) {
            params.lookupFields = {}
          }
          params.lookupFields[key] = this.params[key]
        }
      })

      this.loadingInstance = this.$loading({
        lock: true,
        fullscreen: true,
        text: '',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      logApi
        .getLogsList(params)
        .then(data => {
          if (data.code === '00000000') {
            let result = data.payload.data
            this.tableData = result.logs
            this.scrollId = result.scrollId
            this.listOver = result.listOver
          } else {
            this.errorMessage(data.message)
          }

          this.loadingInstance.close()
        })
        .catch(e => {
          this.loadingInstance.close()
          this.errorMessage(e.message)
        })
    },
    loadMore () {
      this.loading = true
      this.loadingInstance = this.$loading({
        lock: true,
        fullscreen: true,
        text: '',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      let params = {
        lookupFields: {
          appCode: ''
        }
      }
      if (this.scrollId) {
        params.scrollId = this.scrollId
      }
      if (this.timePick && this.timePick.length === 2) {
        params.startTime = this.timePick[0].getTime()
        params.endTime = this.timePick[1].getTime()
      }
      if (this.appLog && this.appInfo.appKey) {
        this.params.appKey = this.appInfo.appKey
      }
      Object.keys(this.params).forEach(key => {
        if (this.params[key] !== '') {
          if (!params.lookupFields) {
            params.lookupFields = {}
          }
          params.lookupFields[key] = this.params[key]
        }
      })
      logApi
        .getLogsList(params)
        .then(data => {
          if (data.code === '00000000') {
            let result = data.payload.data
            this.listOver = result.listOver
            if (!result.listOver) {
              this.tableData.push(...result.logs)
              this.scrollId = result.scrollId
            }
          } else {
            this.errorMessage(data.message)
          }
          this.loading = false
          this.loadingInstance.close()
        })
        .catch(e => {
          this.loading = false
          this.loadingInstance.close()
          this.errorMessage(e.message)
        })
    },

    copy () {
      var clipboard = new Clipboard('.tag-read')
      clipboard.on('success', e => {
        this.$notify({
          title: this.$t('apiLog.success'),
          message: this.$t('apiLog.copySucess'),
          type: 'success'
        })
        clipboard.destroy() // 释放内存
      })
      clipboard.on('error', e => {
        this.$notify({
          title: this.$t('apiLog.fail'),
          message: this.$t('apiLog.copyError'),
          type: 'warning'
        })
        clipboard.destroy() // 释放内存
      })
    }
  }
}
</script>
<style scoped lang="less">
.load-more-cla {
    padding: 5px;
    text-align: center;

    .load-more-btn-cla {
        color: #909399;

        :hover {
            color: #7ace43;
        }
    }
}

/deep/.el-drawer__body {
    margin-bottom: 0px;
    overflow-y: auto;
}

/deep/.el-drawer__header {
    margin-bottom: 0px;
}

.api-row-cla {
    border-bottom: 0.083333rem solid #e3e8ee;
    padding: 5px 15px;
}

.tag-read {
    margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/ApiLog/ApiLog.vue